<div class="table-responsive mb-3">
  <table class="table table-sm align-middle excel-import-preview-table">
    <caption class="caption-top fw-bold">
      {{
        title()
      }}
    </caption>
    <thead>
      <tr>
        <th scope="col">
          <span class="visually-hidden">{{ title() }}</span>
        </th>
        @for (year of years(); track year) {
          <th scope="col" class="text-end">{{ columnLabels()[year] ?? year }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track row.id) {
        <tr>
          <th scope="row">{{ row.label }}</th>
          @for (cell of row.cells; track cell.ar) {
            <td class="text-end">
              <div class="small text-muted">
                <span class="visually-hidden">{{ texts().current }}</span>
                {{ cell.current | number: '1.0-0' : 'sv' }}
              </div>
              @if (cell.imported !== undefined) {
                <div
                  class="fw-bold"
                  [title]="
                    cell.source ? texts().source + ': ' + cell.source : ''
                  "
                >
                  <span class="visually-hidden">{{ texts().imported }}</span>
                  {{ cell.imported | number: '1.0-0' : 'sv' }}
                </div>
              } @else {
                <div class="text-muted" aria-hidden="true">–</div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
